import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "src/app/store";
import { UserType } from "../types/UserType";
import { apiClient } from "src/utils/Api/apiClient";
import { getUserById } from "./userResponsibility";
import { useDispatch } from "react-redux";

interface userState {
        user: UserType | null;
        userLoading: boolean;
        userError: string | null;
}

const initialState: userState = {
        user: null,
        userLoading: false,
        userError: null
}

export const createUser = createAsyncThunk(
        'user/createUser',
        async (userData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('user/createUser', userData);
                        return response.data;
                } catch (userError: any) {
                        return rejectWithValue(userError.response.data || 'An error occured');
                }
        }
);

export const updateUser = createAsyncThunk(
        'user/updateUser',
        async (userData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('user/updateUser', userData).then();
                        return response.data;
                } catch (userError: any) {
                        return rejectWithValue(userError.response.data || 'An error occured');
                }
        }
);

const userSlice = createSlice({
        name: 'user',
        initialState,
        reducers: {
                reset: () => initialState,
                userReset: () => initialState,
        },
        extraReducers: (builder) => {
                //add users to server
                builder.addCase(createUser.pending, (state) => {
                        state.userLoading = true;
                        state.userError = null;
                });
                builder.addCase(createUser.fulfilled, (state, action) => {
                        state.userLoading = false;
                        state.user = action.payload;
                });
                builder.addCase(createUser.rejected, (state, action) => {
                        state.userLoading = false;
                        state.userError = action.payload as string;
                });

                //updated users to server
                builder.addCase(updateUser.pending, (state) => {
                        state.userLoading = true;
                        state.userError = null;
                });
                builder.addCase(updateUser.fulfilled, (state, action) => {
                        state.userLoading = false;
                        state.user = action.payload;
                });
                builder.addCase(updateUser.rejected, (state, action) => {
                        state.userLoading = false;
                        state.userError = action.payload as string;
                });
        }
});

export const { reset, userReset } = userSlice.actions;
export default userSlice.reducer;
